<template>
  <form class="reset-password-form">
    <h1 class="text-center">Multi-factor Authentication</h1>
    <p class="text-center">A code was sent to {{ sentTo }}.
      <br />Enter the code below to verify.
      <br />Standard messaging rates may apply.
    </p>

    <div class="mt-2 w-35 ly-container large-number-container mfa-input-container">
      <lp-input v-model="code" :max-length="6" compact class="text-center font-weight-bold" placeholder="______" />
    </div>

    <div class="msg msg-error w-100 text-center" v-if="errorMessage">
      {{ errorMessage }}
    </div>

    <div class="ly-row mt-2 ly-even-2">
      <button @click="goBack" type="button">Cancel</button>
      <lp-button @click="verify" type="primary" :loading="isSubmitting"
        :disabled="!code || code?.length !== 6 || isSubmitting">Verify</lp-button>
    </div>
  </form>
</template>

<script setup lang="ts">
import { inject, onMounted, ref } from 'vue'
import { Redirect } from '@/types/redirect'
import { OtpState } from '@/types/otpState'

const otpLoginFlow = inject('otpLoginFlow') as (code: string) => Promise<void>
const getOtpState = inject('getOtpState') as () => OtpState
const redirect = inject('redirect') as Redirect

const code = ref('')
const isSubmitting = ref(false)
const sentTo = ref<string>('')
const errorMessage = ref('')

const goBack = () => {
  redirect('LoginView')
}

onMounted(() => {
  const otpState = getOtpState()
  sentTo.value = otpState.sentTo as string
})

const verify = async (event: Event) => {
  event.preventDefault()
  isSubmitting.value = true
  errorMessage.value = ''

  try {
    await otpLoginFlow(code.value)
  } catch (error) {
    isSubmitting.value = false
    errorMessage.value = 'Invalid MFA Code. The code you entered is incorrect or has expired.'
  }

  isSubmitting.value = false
}
</script>

<style>
.reset-password-form {
  margin: 0px 0px;
  padding: 0px 0px;
}
</style>
